import { useEffect, useRef } from "react";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

export default function HorizontalRail({
  as: Component = "div",
  activeItem,
  scrollActiveIntoView = true,
  scrollBehavior = "smooth",
  snap = false,
  className = "",
  children,
  ...props
}) {
  const railRef = useRef(null);

  useEffect(() => {
    if (!scrollActiveIntoView || activeItem === undefined || activeItem === null) {
      return;
    }

    const activeElement = Array.from(
      railRef.current?.querySelectorAll("[data-rail-item]") || []
    ).find((element) => element.getAttribute("data-rail-item") === String(activeItem));
    const prefersReducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

    if (typeof activeElement?.scrollIntoView !== "function") {
      return;
    }

    activeElement.scrollIntoView({
      behavior: prefersReducedMotion ? "auto" : scrollBehavior,
      block: "nearest",
      inline: "nearest",
    });
  }, [activeItem, scrollActiveIntoView, scrollBehavior]);

  return (
    <Component
      {...props}
      ref={railRef}
      className={joinClassNames(
        "lz-v2-horizontal-rail",
        snap && "lz-v2-horizontal-rail--snap",
        typeof snap === "string" && `lz-v2-horizontal-rail--snap-${snap}`,
        className
      )}
      role={props.role || (props["aria-label"] ? "region" : undefined)}
    >
      {children}
    </Component>
  );
}
